// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6.2002 8.5V3H17.8002V8.5H6.2002Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 21.0001V14.5L19.5 10.5044L4.5 10.5044L2 14.5V21.0001H22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ink-filled')
export default class InkFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ink-filled',
    }
  }
}
